@import './pk-radio-option.variables';

:host {
  @apply block p-[var(--radio--padding)];
}

:host(.is-disabled) {
  @apply opacity-[var(--radio--opacity)];

  label,
  .pk-radio {
    @apply cursor-not-allowed;
  }
}

.pk-radio {
  @include transition(#{'border, background-color'});

  @apply inline-block h-[var(--radio--height)] w-[var(--radio--width)] shrink-0 cursor-pointer appearance-none bg-clip-content outline-none;
  @apply m-[var(--radio--margin)] mr-[var(--radio--margin-right)] rounded-full border-2 p-[var(--radio--padding)];
  @apply border-solid border-[color:var(--radio--off-color)];

  &:checked {
    @apply border-[color:var(--radio--on-color)] bg-[color:var(--radio--on-color)];

    &:hover {
      filter: brightness(120%);
    }
  }

  &:hover {
    filter: brightness(120%);
  }

  &:active {
    filter: brightness(90%);
  }
}

.pk-radio:not(:disabled):focus-visible {
  @apply focus-outline;
}

label {
  @apply text-[length:var(--radio--font-size)] text-[color:var(--radio--label-color)];

  font-family: var(--radio--font-family);
}
